<template>
  <div class="quotes-filter">
    <div class="row q-gutter-x-sm">
      <q-select
        dense
        label="Timezones"
        label-color="white"
        bg-color="grey-6"
        square
        filled
        clearable
        :value="value.timezone"
        :options="timezoneOptions"
        style="min-width: 150px"
        @input="$emit('input', { ...value, timezone: $event })"
      />
      <q-select
        style="min-width: 150px"
        dense
        clearable
        label="Engagements"
        label-color="white"
        bg-color="grey-6"
        square
        filled
        multiple
        emit-value
        map-options
        :value="value.engagements"
        :options="QUOTE_ENGAGEMENTS"
        option-value="value"
        @input="$emit('input', { ...value, engagements: $event })"
      >
        <template #selected-item="scope">
          <q-icon
            :name="scope.opt.icon"
            color="negative"
            size="sm"
            class="q-pa-xs"
          />
        </template>
        <template #option="scope">
          <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
            <q-item-section avatar>
              <q-icon :name="scope.opt.icon" size="md" />
            </q-item-section>
          </q-item>
        </template>
      </q-select>
      <q-select
        style="width: 180px"
        dense
        use-input
        clearable
        label="Status"
        label-color="white"
        bg-color="grey-6"
        square
        filled
        emit-value
        map-options
        :value="value.parentStatusId"
        :options="parentStatusOptions"
        :loading="loadingParentStatus"
        option-label="name"
        option-value="id"
        @filter="filterParentStatusFn"
        @input="$emit('input', { ...value, parentStatusId: $event })"
      />
      <q-select
        style="width: 150px"
        dense
        use-input
        clearable
        label="Child Status"
        label-color="white"
        bg-color="grey-6"
        square
        filled
        emit-value
        map-options
        :value="value.childStatusId"
        :options="childStatusOptions"
        option-label="name"
        option-value="id"
        @filter="filterChildStatusFn"
        @input="$emit('input', { ...value, childStatusId: $event })"
      />
      <q-select
        dense
        style="min-width: 120px"
        emit-value
        map-options
        :value="value.assigneeId"
        label="Assignee"
        label-color="white"
        bg-color="grey-6"
        square
        filled
        :options="[{ id: null, firstName: 'All', lastName: '' }].concat(assignees)"
        option-value="id"
        :option-label="(item) => `${item.firstName} ${item.lastName}`"
        @input="
          $emit('input', {
            ...value,
            assigneeId: $event
          })
        "
      />
    </div>
  </div>
</template>

<script>
import graphql from '@client/graphql';
import { QUOTE_ENGAGEMENTS } from '@server/constants';

export default {
  name: 'AppQuotesFilter',
  props: {
    value: Object,
    context: String,
    reassigning: Boolean
  },
  apollo: {
    assignees: {
      query: graphql.queries.loadAssignees
    },
    parentStatuses: {
      query: graphql.queries.getParentStatus,
      variables() {
        return { type: this.context === 'quote' ? 'QUOTE' : 'ORDER' };
      },
      watchLoading(isLoading) {
        this.loadingParentStatus = isLoading;
      },
      result(result) {
        if (result.loading) return;

        this.parentStatusOptions = result.data.parentStatuses;
        const parentStatus = this.parentStatusOptions.find(
          (s) => s.id === this.value.parentStatusId
        );
        this.childStatusOptions = parentStatus ? parentStatus.children : [];
      }
    }
  },
  data() {
    return {
      selectedAssignee: null,
      loadingParentStatus: false,
      parentStatusOptions: [],
      childStatusOptions: [],
      timezoneOptions: ['EST', 'CST', 'MT', 'PST'],
      QUOTE_ENGAGEMENTS
    };
  },
  methods: {
    filterParentStatusFn(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.parentStatusOptions = this.parentStatuses.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterChildStatusFn(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        const parentStatus = this.parentStatuses.find(
          (s) => s.id === this.value.parentStatusId
        );
        this.childStatusOptions = parentStatus
          ? parentStatus.children.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            )
          : [];
      });
    }
  }
};
</script>

<style lang="scss">
.quotes-filter {
  .q-field__marginal,
  .q-field__native {
    color: #fff;
  }
}
</style>
